import styled from 'styled-components/macro';

import { lowHeightScreens, mediumScreens, smallScreens } from '../../common/fontElements';
import * as colors from '../../common/colorConstants';
import TicketButton from 'components/Buttons/TicketButton/TicketButton';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
`;

export const PageHeader = styled.div`
  align-self: flex-start;
  display: flex;
  align-items: center;
  height: 5rem;
  padding: 1.5rem 15px;
  height: 45px;
`;

export const BackButton = styled.div`
  height: 100%;
  margin-left: 5px;
  padding: 0 10px 23px;
  cursor: pointer;
`;

export const Header = styled.div`
  padding: 10px 15%;
  text-align: center;
  font-size: 18px;
  color: #154d57;
  font-family: Lato-Light, sans-serif;

  @media screen and (max-width: ${mediumScreens}) {
    padding: 10px 10%;
    font-size: 16px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 14px;
  }
`;

export const HeaderDescription = styled.div`
  padding: 10px 10%;
  text-align: center;
  font-size: 14px;
  font-weight: normal;
  color: #484a4f;
  font-family: Lato, sans-serif;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 12px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    padding: 10px 5%;
    font-size: 11px;
  }
`;

export const BorderedBox = styled.div`
  border-radius: 9px;
  background: ${colors.baseBackground};
  border: 1px solid ${colors.lightGray15};
  margin: 5px 30px;

  @media screen and (max-width: ${mediumScreens}) {
    margin-left: 20px;
    margin-right: 20px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    margin-left: 15px;
    margin-right: 15px;
  }
`;

export const SearchSection = styled(BorderedBox)`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  flex-shrink: 0;
  padding: 10px 30px 20px;

  & > * {
    margin: 5px auto;
    width: 100%;
  }
`;

export const SearchByLetterBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  padding: 0 10px;
  width: 100%;
  flex: 1;
`;

export const SearchBoldText = styled.div`
  font-weight: bold;
  font-family: Lato, sans-serif;
  font-size: 12px;

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 10px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 9px;
  }
`;

export const SearchByLetterLabel = styled(SearchBoldText)`
  margin-top: 20px;
  padding: 5px;
  line-height: 1;
  color: #484a4f;
  user-select: none;
  text-align: center;
`;

export const SearchLetter = styled(SearchBoldText)`
  padding: 5px 2px;
  cursor: ${(props) => (props.active ? 'pointer' : 'not-allowed')};
  color: ${(props) =>
    // eslint-disable-next-line
    props.selected ? '#111111' : props.active ? '#333333' : '#8A9097'};
  text-decoration: ${(props) => (props.selected ? 'underline' : 'none')};
  font-family: Lato, sans-serif;
  user-select: none;

  &:hover {
    color: ${(props) => (props.active ? '#007d7d' : '#8A9097')};
  }
  &:active {
    color: ${(props) => (props.active ? '#00acac' : '#8A9097')};
  }
`;

export const SearchResultsWrapper = styled(BorderedBox)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  flex-shrink: 1;
  min-height: 0;

  margin-top: 30px;
  padding: 10px 30px;
`;

export const SearchResultsLabel = styled(SearchBoldText)`
  padding: 10px 0;
  text-align: center;
  color: #484a4f;
`;

export const SearchResults = styled.div`
  padding: 10px 10%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
  align-items: center;
  overflow-y: auto;

  flex-shrink: 1;
  min-height: 0;

  @media screen and (max-width: ${mediumScreens}) {
    padding: 10px 40px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    padding: 10px 30px;
  }
`;

export const SearchResult = styled(SearchBoldText)`
  display: block;
  position: relative;

  padding: 5px ${(props) => (props.hasShipstation ? '25px' : '15px')} 5px 15px;
  margin: 5px;
  border: 1px solid #c2c4cc;
  background-color: ${(props) => (props.active ? '#DADEE8' : '#ffffff')};
  border-radius: 2.5px;
  cursor: pointer;
  user-select: none;
  width: auto;
  min-width: 90px;
  box-sizing: border-box;

  text-align: center;
  line-height: 13px;
  color: #484a4f;

  &:focus {
    outline: none;
  }

  .tooltip-icon {
    position: absolute;
    right: 5px;
    top: 5px;
  }
`;

export const ContinueButton = styled(TicketButton)`
  margin: 10px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
